import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import { useGlobalStore } from '../../store/globalStore'

function NoContextModal() {
    const user = useGlobalStore(state => state.user)
    const dislosure = useDisclosure()
    const [text, setText] = useState('')

    const texts = [
        "Чтобы начать пользоваться сервисом, попроси своего руководителя назначить тебе контекст",
        "Ура! Тебе назначили контекст! Можешь выбрать его, нажав на аватар в правом верхем углу",
    ]

    useEffect(() => {
        if (!user?.contexts || user.contexts.length < 1) {
            setText(texts[0])
            dislosure.onOpen()
        } else if (!user?.active_context) {
            setText(texts[1])
            dislosure.onOpen()
        }
    }, [user])

    return (
        <Modal
            isCentered
            onClose={dislosure.onClose}
            isOpen={dislosure.isOpen}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Добро пожаловать!</ModalHeader>
                <ModalBody>
                    {text}
                </ModalBody>
                <ModalFooter />
            </ModalContent>
        </Modal>
    )
}

export default NoContextModal
